export const Enums = {
	menuTypeEnum: {
		'0': {
			text: '菜单',
		},
		'1': {
			text: '页面',
		},
		// "2": {
		//   text: '页面权限',
		// },
	},
	userFlag: {
		'1': {
			text: '正常',
		},
		'2': {
			text: '停用',
		},
		'3': {
			text: '锁定',
		}
	},
	yesNoEnum: {
		'1': {
			text: '是',
		},
		'0': {
			text: '否',
		}
	},

	/**委员信息 -- 委员状态*/
	wyxx_wyzt: {
		0: {
			text: '现任委员',
		},
		1: {
			text: '离任委员',
		}
	},
	/**委员信息 -- 是否在常务委员会*/
	wyxx_sfcwwy: {
		0: {
			text: '否',
		},
		1: {
			text: '是',
		}
	},
	/**委员信息 -- 性别*/
	wyxx_xb: {
		0: {
			text: '女',
		},
		1: {
			text: '男',
		}
	},
	activityEnum: {
		'proposal': {
			value: 'tagl',
			name: '提案'
		},
		'publicopinion': {
			value: 'sqmygl',
			name: '社情民意'
		},
		'consultation': {
			value: 'xsjdhdgl',
			name: '协商监督'
		},
		'inspection': {
			value: 'sckcdygl',
			name: '视察调研'
		},
		'study': {
			value: 'llxxgl',
			name: '学习培训'
		}
		,
		'meetingspeech': {
			value: 'dhfygl',
			name: '大会发言'
		},
		'donation': {
			value: 'jkjwjl',
			name: '捐款捐物'
		}
		,
		'workreport': {
			value: 'bzgzhb',
			name: '本职工作'
		}
		,
		'servingactivity': {
			value: 'fwwmhd',
			name: '服务为民'
		}
		,
		'lectureactivity': {
			value: 'wyjxhd',
			name: '委员讲习'
		}
		,
		'meetingmanager': {
			value: 'hygl',
			name: '会议管理'
		}
		,
		'suggestionreply': {
			value: 'jyyjhfgl',
			name: '建议意见回复管理'
		}
		,
	},
	//会议管理-会议状态
	hyztEnum: {
		'DFB': {
			value: 0,
			text: '待发布',
		},
		'DKS': {
			value: 1,
			text: '待开始'
		},
		'YJS': {
			value: 2,
			text: '已结束'
		},
		'YGB': {
			value: 3,
			text: '已关闭'
		},
	},

	//委员信息-委员会职务
	wyxx_wyhzw: {
		'0': { text: '主席' },
		'1': { text: '副主席' },
		'2': { text: '秘书长' },
		'3': { text: '常务委员' },
	},


};
export const MapTypes = {
	tianditu: 'WGS-84',
	gaode: 'GCJ-02',
	baidu: 'WGS-84'
}
export const getEnumValue = (enumName: any, key: any) => {
	// console.log(enumName, key, Enums[enumName][key] && Enums[enumName][key].text);
	return Enums[enumName][key] && Enums[enumName][key].text;
};
export const getEnumsOption = (enumName: any) => {
	return Object.keys(Enums[enumName])?.map(el => { return { label: Enums[enumName][el]?.text, value: el }; });
};


/**
 * 
// 多选下拉选择框数据渲染配置
// 如果本地配置有从本地取，如果没有从配置表取
 * @param enumName 
 * @param key 可以为数组 或用逗号分割的字符串
 * @param initialState  全局数据
 * @returns 
 */
export const getMultipleEnumValueAll = (enumName: any, key: any, initialState: any) => {

	if (Array.isArray(key) || key.includes(",")) {// 如果多选
		const keyArray: any = Array.isArray(key) ? key : key.includes(",");
		const textArray: any = [];
		// 已绑定数据直接从绑定数据匹配
		if (typeof (enumName) != 'string') {
			keyArray.forEach((el: any) => {
				enumName[el] && enumName[el].text ? textArray.push(enumName[el].text) : null
			});
			return textArray.length > 0 ? textArray.join(",") : null;
		}
		if (Enums[enumName]) {
			const textArray: any = [];
			keyArray.forEach((el: any) => {
				Enums[enumName][el] && Enums[enumName][el].text ? textArray.push(Enums[enumName][el].text) : null
			});
			return textArray.length > 0 ? textArray.join(",") : null;
		}

		return initialState.codelist.data.filter(
			(el: { dldm: string; jlzt: number; csdm: string }) => el.dldm == enumName && keyArray.includes(el.csdm),
		) ? initialState.codelist.data.filter(
			(el: { dldm: string; jlzt: number; csdm: string }) => el.dldm == enumName && keyArray.includes(el.csdm),
		)?.map((i: any) => {
			return i.csmc
		}).join(",") : null;
	}

	// 只选择了一个
	// 已绑定数据直接从绑定数据匹配
	if (typeof (enumName) != 'string') {
		return enumName[key] && enumName[key].text;
	}
	if (Enums[enumName]) {
		return Enums[enumName][key] && Enums[enumName][key].text;
	}
	return initialState.codelist.data.find(
		(el: { dldm: string; jlzt: number; csdm: string }) => el.dldm == enumName && el.csdm == key,
	) && initialState.codelist.data.find(
		(el: { dldm: string; jlzt: number; csdm: string }) => el.dldm == enumName && el.csdm == key,
	).csmc;

};


/**
 * 
// 如果本地配置有从本地取，如果没有从配置表取
 * @param enumName 
 * @param key 
 * @param initialState  全局数据
 * @returns 
 */
export const getEnumValueAll = (enumName: any, key: any, initialState: any) => {

	// 已绑定数据直接从绑定数据匹配
	if (typeof (enumName) != 'string') {
		return enumName[key] && enumName[key].text;
	}
	if (Enums[enumName]) {
		return Enums[enumName][key] && Enums[enumName][key].text;
	}
	return initialState.codelist.data.find(
		(el: { dldm: string; jlzt: number; csdm: string }) => el.dldm == enumName && el.csdm == key,
	) && initialState.codelist.data.find(
		(el: { dldm: string; jlzt: number; csdm: string }) => el.dldm == enumName && el.csdm == key,
	).csmc;
};
/**
 * // 如果本地配置有从本地取，如果没有从配置表取
 * @param enumName
 * @param initialState 全局数据
 * @returns
 */
export const getEnumsOptionAll = (enumName: any, initialState: any) => {

	// 已绑定数据直接从绑定数据匹配
	if (typeof (enumName) != 'string') {
		return Object.keys(enumName)?.map((el) => {
			return { label: enumName[el]?.text, value: el };
		});
	}
	if (Enums[enumName]) {
		return Object.keys(Enums[enumName])?.map((el) => {
			return { label: Enums[enumName][el]?.text, value: el };
		});
	}
	return initialState?.codelist?.data
		?.filter((el: { dldm: string; jlzt: number }) => el.dldm == enumName)
		?.map((el: { csmc: any; csdm: any }) => {
			return { label: el.csmc, value: el.csdm };
		});
};
/**
 * // 如果本地配置有从本地取，如果没有从配置表取
 * @param enumName
 * @param initialState 全局数据
 * @returns
 */
export const getEnumsItemAll = (enumName: any, initialState: any) => {

	// 已绑定数据直接从绑定数据匹配
	if (typeof (enumName) != 'string') {
		return enumName;
	}

	if (Enums[enumName]) {
		return Enums[enumName];
	}
	const obj = {};
	initialState.codelist?.data
		?.filter((c: { dldm: any }) => c.dldm == enumName)
		?.forEach((c: { csdm: string | number; csmc: any }) => {
			obj[c.csdm] = {
				text: c.csmc,
			};
		});
	//  console.log("getEnumsItemAll", obj);
	return obj;
};
